/* @ts-ignore */
import * as React from 'react';
import { AutoComplete, Form, Input, Modal, Select } from 'antd';
import { transformFormatSource } from '@ui/tools/transformSource';
import { entityTypes } from '../config';

const { Item } = Form;
const { Option } = Select;

export default Form.create({ name: 'create-entity' })(
  // @ts-ignore
  class extends React.Component {
    state = {
      typeEntity: 'country',
    };

    handleChangeTypeEntity = (typeEntity: any) => {
      this.setState({ typeEntity });
    };

    render() {
      const {
        // @ts-ignore
        onCreate,
        // @ts-ignore
        onCancel,
        // @ts-ignore
        form: { getFieldDecorator },
        // @ts-ignore
        isVisible,
        // @ts-ignore
        entities,
      } = this.props;

      const { typeEntity } = this.state;

      const entity = entityTypes[typeEntity];

      const sources = entity.manyName
        ? transformFormatSource(entities[entity.manyName])
        : [];

      return (
        <Modal
          okButtonProps={{
            style: {
              width: '120px',
            },
            size: 'large',
          }}
          cancelButtonProps={{
            style: {
              width: '120px',
            },
            size: 'large',
          }}
          okText="Сохранить"
          cancelText="Отмена"
          visible={isVisible}
          onOk={() => onCreate(typeEntity)}
          onCancel={onCancel}
        >
          <Select value={typeEntity} onChange={this.handleChangeTypeEntity}>
            {Object.values(entityTypes).map(item => (
              <Option value={item.key}>{item.label}</Option>
            ))}
          </Select>
          <Form>
            <Item label="Название">
              {getFieldDecorator('name', {
                rules: [
                  { required: true, message: 'вы должны заполнить поле' },
                ],
              })(<Input />)}
            </Item>
            {entity.dependencies &&
              entity.dependencies.map((dependency: any) => (
                <Item label={dependency.label}>
                  {getFieldDecorator(dependency.name, {
                    rules: [
                      { required: true, message: 'вы должны заполнить поле' },
                    ],
                  })(<AutoComplete dataSource={sources} />)}
                </Item>
              ))}
          </Form>
        </Modal>
      );
    }
  },
);



// WEBPACK FOOTER //
// ./src/scenes/Stores/containers/CreateEntity.tsx